// src/components/SuccessSection.jsx
import { FaChartLine, FaHandshake, FaRocket } from 'react-icons/fa';

const proofPoints = [
  {
    icon: FaChartLine,
    headline: '200% lift in leads',
    description: 'Local HVAC brand doubled pipeline in 60 days with a refreshed site + Google Ads.',
  },
  {
    icon: FaRocket,
    headline: '3.4x return on ad spend',
    description: 'E-commerce client scaled Meta campaigns while cutting acquisition costs in half.',
  },
  {
    icon: FaHandshake,
    headline: '90-day partner retention',
    description: 'Every engagement includes weekly scorecards and optimisations that keep momentum high.',
  },
];

export default function SuccessSection() {
  return (
    <section className="bg-gradient-to-br from-sky-900 via-slate-900 to-slate-950 py-20">
      <div className="mx-auto flex max-w-6xl flex-col gap-10 px-5 text-center text-white md:px-6 md:text-left">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="space-y-3">
            <p className="text-sm uppercase tracking-[0.2em] text-sky-300/80">Real results</p>
            <h2 className="text-3xl font-semibold md:text-4xl">Clients trust us because revenue goes up.</h2>
            <p className="max-w-2xl text-slate-200">
              Every month we show leads earned, sales closed, and what we’re testing next. A few quick wins below:
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="/projects"
              className="inline-flex items-center justify-center rounded-full border border-sky-400 px-5 py-3 text-sm font-semibold text-sky-100 transition hover:border-white hover:text-white"
            >
              View live projects
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center rounded-full bg-white/10 px-5 py-3 text-sm font-semibold text-white shadow-inner hover:bg-white/20"
            >
              Plan my sprint →
            </a>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {proofPoints.map(({ icon: Icon, headline, description }) => (
            <div
              key={headline}
              className="rounded-3xl border border-white/10 bg-white/5 p-6 text-center backdrop-blur transition hover:border-sky-300/40 hover:bg-white/10"
            >
              <Icon className="mx-auto text-4xl text-sky-300" />
              <h3 className="mt-4 text-xl font-semibold">{headline}</h3>
              <p className="mt-3 text-sm text-slate-200">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
